import React, { useEffect } from 'react';

import { initPopupManager } from '@eika-infrastruktur/popup-lib';

import { useConfig } from '../../defaultConfig';

const PopupManager: React.FC = () => {
    const {
        featureToggles: { disableWaitingForPopupClients },
    } = useConfig();

    useEffect(() => {
        return initPopupManager({ disableWaitingForClients: disableWaitingForPopupClients });
    }, [disableWaitingForPopupClients]);

    return null;
};

export default PopupManager;
